let handlers = [];
let initialized = false;
let lastExitAt = 0;

export function pushAndroidBackHandler(handler) {
    if (typeof handler !== "function") {
        return () => {};
    }

    handlers.push(handler);
    return () => {
        handlers = handlers.filter((item) => item !== handler);
    };
}

function runHandlers() {
    for (let index = handlers.length - 1; index >= 0; index -= 1) {
        try {
            if (handlers[index]()) {
                return true;
            }
        } catch (_) {
            // ignore broken handlers
        }
    }
    return false;
}

export function initAndroidBackButton() {
    if (initialized) return;
    if (!window?.Capacitor?.isNativePlatform?.()) return;

    const App = window.Capacitor?.Plugins?.App;
    if (!App?.addListener) return;

    initialized = true;

    App.addListener("backButton", () => {
        if (runHandlers()) return;

        if (window.history.length > 1) {
            window.history.back();
            return;
        }

        const now = Date.now();
        if (now - lastExitAt < 2500) {
            App.exitApp?.();
            return;
        }

        lastExitAt = now;
    });
}
